function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cmnd_blur_svg__clip0_193_10343)",
  filter: "url(#cmnd_blur_svg__filter0_d_193_10343)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.266 31.63C3.96 31.123 4 30.563 4 30.006c0-8.212-.003-16.424 0-24.633C4.006 1.857 5.922.003 9.535 0 24.477 0 39.418-.01 54.36.01c1.368 0 2.79.014 3.792 1.202.334.834 0 1.266-.86 1.382-1.944-1.023-4.056-.929-6.167-.925a13461.1 13461.1 0 01-39.974-.007c-1.783-.003-3.374.302-4.597 1.678-.653.673-.793 1.544-.79 2.393.004 8.529-.216 17.06.118 25.589-.371 1.23-.44 1.242-1.616.307z",
  fill: "#B7D6C6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.533 2.424c.405-.305.573-.728.619-1.21 1.368.838 1.83 2.147 1.832 3.624.02 8.523.016 17.048.007 25.57 0 2.187-1.291 3.794-3.362 4.29-.538.265-1.114.135-1.668.135-15.691.009-31.38.006-47.067.006-2.507-.03-3.557-.956-3.597-3.164l-.03-.049c.43-.396.86.829 1.29 0a.585.585 0 01.557.037c1.378 1.62 3.164 1.985 5.247 1.976 13.345-.058 26.69-.052 40.03-.01 2.3.007 4.526-.017 6.448-1.47.514.025.855-.115.972-.703.109-.551.158-1.1.158-1.654.003-7.937.006-15.878 0-23.816 0-.804-.096-1.598-.229-2.39-.003-.021-.093-.046-.133-.034-.043.013-.08.061-.127.1-.77-.078-1.009-.547-.947-1.235v-.003z",
  fill: "#B9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.352 34.717c16.425-.006 32.852-.012 49.277-.015-.238.368-.622.295-.972.295-16.1-.01-32.202-.021-48.302-.033-.068-.055-.09-.107-.068-.162.022-.055.044-.082.065-.082v-.003z",
  fill: "#B2D1D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.149 32.245c-1.427 1.546-3.207 1.887-5.287 1.878-14.267-.067-28.534-.046-42.801-.021-1.944 0-3.393-.658-4.207-2.451.319-.503-.062-1.453.981-1.498 1.068 1.763 2.675 2.274 4.702 2.265 13.763-.049 27.522-.021 41.285-.027 3.216 0 4.219-.996 4.225-4.217a4806.8 4806.8 0 000-21.144c-.01-3.072-1.062-4.116-4.191-4.122-14.175-.03-28.349.027-42.52-.034-1.256-.006-2.16.545-2.829 1.541-.25.374-.371.846-.808 1.087-1.185-.612-.374-1.635-.526-2.46 1.12-1.325 2.526-1.864 4.303-1.858 14.044.04 28.088.04 42.129-.003 1.792-.006 3.476.092 4.925 1.249.31.408.622.813.931 1.22.533.384.53.972.61 1.53.022 8.29.007 16.584.007 24.875-.01.856-.168 1.65-.935 2.196l.006-.006z",
  fill: "#CFEEDC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.48 30.12c-.143.535.374 1.33-.623 1.53-.099-.002-.2-.008-.3-.018a7.556 7.556 0 01-.325-2.235c.019-7.748.022-15.494 0-23.243-.003-1.154.21-2.202.947-3.118.6.752.164 1.626.3 2.432.58.567.493 1.307.496 2.004.015 6.881.015 13.762 0 20.644 0 .697.086 1.434-.49 2.003H6.48z",
  fill: "#CFEDE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.787 4.86c-.109-.405-.214-.81-.322-1.218l-.068-1.087c.634.228.718.666.808 1.251.355 2.372.167 4.747.179 7.119.034 6.333.012 12.666.01 19 0 .849.018 1.698-.518 2.456-.402.57-.538.165-.727-.14.213-.605.424-1.211.638-1.817.223-.32.145-.682.148-1.032.003-7.835.003-15.67 0-23.503 0-.347.075-.713-.148-1.033v.003z",
  fill: "#B7D6C6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.48 30.12c0-8.219 0-16.434-.004-24.652 1.155-2.755 1.625-3.047 4.873-3.047h41.925c2.965 0 4.265 1.257 4.265 4.125v22.218c0 2.795-1.31 4.102-4.101 4.102-14.079 0-28.157-.04-42.235.04-2.3.011-3.863-.686-4.724-2.787z",
  fill: "#B6D5C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.787 4.86c.464.398.294.937.294 1.421.009 7.573.009 15.145 0 22.72 0 .485.17 1.024-.294 1.426V4.86z",
  fill: "#B9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.59 30.427c-.185.161-.399.475-.553.45-.514-.082-.322-.554-.326-.864-.012-3.496-.043-6.994.02-10.49.027-1.495-.694-3.413.346-4.369.95-.874 2.857-.231 4.34-.256 2.522-.04 5.048.022 7.571-.027.975-.018 1.368.25 1.356 1.279-.047 4.56-.013 9.119-.028 13.68 0 .405.245 1.01-.43 1.123-.58.098-.372-.645-.734-.828-.953-.925-2.303-1.047-3.427-1.623-.278-.219-.424-.538-.616-.822-.16-.219-.359-.405-.51-.633a1.634 1.634 0 01-.174-.6 2.705 2.705 0 01.01-.633c.074-.576.427-1.026.702-1.51.254-.47.684-.829.87-1.343.279-.6.232-1.17-.17-1.705a1.16 1.16 0 01-.025-.634c.415-1.628-.22-2.892-1.588-3.16-1.643-.323-3.11.651-3.368 2.244-.08.493-.028 1.002-.151 1.489-.273.874-.285 1.699.442 2.393.291.393.486.834.718 1.258.13.252.254.505.347.776.09.28.12.566.118.859-.013.295-.065.578-.254.819-.802-.01-.517.904-1.01 1.16-1.163.642-2.664.706-3.472 1.96l-.003.007z",
  fill: "#E3EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.84 31.023c-4.43 0-8.863-.012-13.293.013-.922.006-1.566-.028-1.547-1.249.015-1.135.594-1.178 1.464-1.175 8.912.015 17.827.006 26.738.012.598 0 1.27-.137 1.523.676.353 1.118-.062 1.717-1.284 1.72-4.535.013-9.067.003-13.602.007v-.004z",
  fill: "#7CB798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.363 17.334c-4.48 0-8.959 0-13.438.003-.792 0-1.532.11-1.514-1.105.019-1.12.697-1.03 1.437-1.03 9.06 0 18.124.004 27.184 0 .737 0 1.418-.094 1.436 1.03.019 1.215-.72 1.105-1.513 1.105-4.532-.006-9.06 0-13.592 0v-.003z",
  fill: "#7DB797"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.82 21.91c-4.432 0-8.868-.003-13.3.003-.796 0-1.536.104-1.514-1.108.018-1.117.693-1.038 1.436-1.038 8.97.003 17.941.006 26.912 0 .74 0 1.418-.095 1.436 1.029.019 1.209-.712 1.114-1.51 1.111-4.486-.006-8.97-.003-13.456-.003l-.003.006z",
  fill: "#7FB698"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.824 26.472c-4.38 0-8.763.003-13.143-.007-.78 0-1.69.262-1.672-1.102.018-1.27.857-1.026 1.588-1.029 8.865-.006 17.73-.006 26.6 0 .724 0 1.569-.256 1.59 1.023.022 1.361-.876 1.108-1.662 1.108-4.433.01-8.865.003-13.298.003l-.003.004z",
  fill: "#7EB697"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.668 4.869l28.785-.01c.331 2.095.223 2.217-1.888 2.037-.644-.401-1.365-.395-2.09-.392h-21.5c-.67 0-1.347-.043-1.945.35-.582.155-1.151.216-1.678-.17l.032-.05c-.363-.66-.177-1.236.284-1.768v.003z",
  fill: "#E36E62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.645 10.873c-7.831 0-15.663 0-23.494.003-.34-1.927-.254-2.05 1.585-2.055.715 0 1.433-.064 2.142.085.69.435 1.467.393 2.24.393 5.096 0 10.188-.006 15.283.006.712 0 1.446-.104 2.124.234.424.408.355.862.123 1.33l-.003.004z",
  fill: "#E37065"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.58 6.65c1.542.332 2.158-.274 1.87-1.79.6.639.204 1.412.294 2.122-.322.231-.694.152-1.043.152-9.098.003-18.192.003-27.29 0-.353 0-.724.07-1.052-.137 0-.104-.007-.207-.01-.308.52-.012 1.037-.027 1.557-.04.505-.352 1.087-.261 1.644-.261 7.463-.006 14.923-.006 22.387 0 .557 0 1.142-.091 1.643.265V6.65z",
  fill: "#B2B2A5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.359 6.997c9.794-.006 19.59-.012 29.385-.015-.393.484-.947.307-1.436.307-8.835.01-17.67.01-26.504 0-.492 0-1.04.17-1.445-.289v-.003z",
  fill: "#CCCCBF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.645 10.873l-.012-1.154c-.539-.426-1.18-.286-1.783-.29-5.349-.011-10.695 0-16.044-.011-.656 0-1.346.149-1.947-.271-.665-.01-1.34.051-1.993-.043-1.477-.213-1.95.432-1.715 1.775-.638-.612-.201-1.361-.279-2.046.263-.213.582-.161.886-.161H51.06c.3 0 .622-.061.873.182-.09.673.319 1.416-.285 2.019h-.003z",
  fill: "#B78276"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.933 8.851l-24.06-.021c.324-.472.829-.317 1.265-.317 7.179-.006 14.36-.003 21.538.006.437 0 .945-.161 1.254.335l.003-.003z",
  fill: "#F0BBAE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.299 12.088C9.987 10.416 9.55 8.11 12.054 5.526c.257.17.428.39.425.71-1.075 2.253-1.034 3.236.164 4.278.337.292.814.417 1.033.846.065.338-.154.533-.377.725v.003z",
  fill: "#D97874"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.37 6.084c-.235-.113-.31-.317-.316-.558 2.105-1.394 4.504-.782 5.597 1.428.115.296-.059.405-.306.472-.34 0-.582-.198-.774-.432-.932-1.124-2.093-1.37-3.452-.904-.244.082-.498.118-.746-.006h-.003z",
  fill: "#DD7469"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.242 7.326l.406-.372c1.093 2.363.21 4.178-2.504 5.161-.149-.32-.084-.633.015-.95 1.57-.822 1.678-2.408 2.083-3.84z",
  fill: "#D37E72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.668 5.438c-.155-.22-.214-.262-.207-.295.145-.825.6-1.462 1.3-1.906.185-.12.396.082.371.307-.093.956-.963 1.233-1.467 1.894h.003z",
  fill: "#C3D0C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.107 11.534c.362.173.105.383.037.584l-1.845-.027c.003-.238.083-.432.313-.545.495-.417.993-.411 1.495-.012z",
  fill: "#E6725C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.668 4.869c-.108.587-.405 1.144-.284 1.769-.366-.661-.812-1.337.284-1.77z",
  fill: "#DA8A7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.438 21.292c-.052-3.157 1.236-4.619 3.774-4.287a2.446 2.446 0 011.814 3.688 2.302 2.302 0 01-.381.255c-.362.125-.743.119-1.117.125-.706-.012-1.424 0-2.016-.469-.55-.432-.795-.146-.962.369a1.058 1.058 0 01-.474.453c-.235.067-.452.043-.638-.134z",
  fill: "#314357"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.044 21.286c1.031.475.669 1.154.276 1.84-.52.261-.802.697-.929 1.242-.216.502-.436 1.007-.653 1.51-1.325.931-1.774.883-2.749-.308-.238-.137-.319-.359-.337-.615.13-.222.331-.38.55-.496.998-.533 1.71-1.206 1.44-2.463-.05-.232.093-.481.205-.707a.786.786 0 01.464-.393c.594.007.82.588 1.285.798.674.43-.072-.67.448-.405v-.003z",
  fill: "#E7A897"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.14 21.29c-.074.291-.275.62-.204.873.57 2.01-.962 2.308-2.284 2.792-.372-.332-.554-.755-.616-1.236-.539-.813-.595-1.626.01-2.436l.237-.335c.972-.052 1.975-.35 2.854.344l.004-.003z",
  fill: "#EFA592"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.955 27.352l.084-.89a20.06 20.06 0 012.671-.015l.093.6c-.043.36-.297.594-.517.85-.36.25-.477.846-1.086.74l-.007-.007c-.38-.377-.891-.615-1.194-1.078l-.047-.197.003-.003z",
  fill: "#EEA28D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2 28.633c.322-.304.44-.803.938-.938.383-.182.69-.645 1.213-.316.12.283.238.57.359.852-.811.296-1.554.99-2.51.402z",
  fill: "#8D898D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.045 21.28l-.01 2.436c-1.237-.56-1.157-1.434-.597-2.424l.607-.012z",
  fill: "#CBA5A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.71 26.444c-.888.396-1.777.387-2.671.015l-.05-.892c.83.834 1.786.6 2.749.308l-.028.566v.003z",
  fill: "#D17C6D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.59 28.819l-1.579-.575c.174-.445.062-1.179.947-.896l.04.104c.217.447 1.245.551.595 1.364l-.003.003z",
  fill: "#8595A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.391 24.367c-.04-.666-.083-1.336.929-1.242-.053.6-.675.789-.929 1.242z",
  fill: "#E6A59B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.044 21.286c-.21.159.304.764-.396.621-.294-.41-.294-.81.04-1.2.112-.005.226-.012.338-.015l.018.594z",
  fill: "#653F3C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.35 27.379l-1.213.316c.118-.32.36-.517.666-.648.238.021.48.037.548.335v-.003z",
  fill: "#B9A19F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.58 6.65H26.906c.134-.75.743-.567 1.217-.567 7.745-.009 15.493-.009 23.238 0 .476 0 1.083-.182 1.216.57l.003-.003z",
  fill: "#EC6C59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.862 9.144c6.2-.01 12.4-.022 18.604-.019.467 0 1.096-.204 1.17.591-6.135.003-12.27.012-18.406 0-.504 0-1.2.277-1.368-.572z",
  fill: "#EC6A59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.59 28.819c.192-.618-.58-.831-.595-1.364.545.25 1.27.314 1.201 1.172l-.606.192z",
  fill: "#8D898D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.107 11.534c-.499.003-.997.006-1.496.012-2.699-1.233-3.117-3.578-1.24-5.46 2.231-1.102 3.376-.81 4.874 1.243.372 1.936-.318 3.35-2.138 4.205z",
  fill: "#FBC9B1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.14 21.29c-.903-.494-1.99.46-2.854-.345l.155-1.48c1.046.485 1.762 1.562 3.01 1.252.07.064.095.125.07.186-.025.06-.05.09-.074.09-.102.098-.204.196-.31.293l.003.003z",
  fill: "#D4A6A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.447 20.997v-.28l1.238-.01c-.012.4-.028.801-.04 1.2-.786.192-.761-.654-1.201-.91h.003z",
  fill: "#CFA8A5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.156 21.865c.019.819.232 1.336-.31 1.814-.411-.654.022-1.053.31-1.814z",
  fill: "#E0977C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.469 9.743c-.923 1.057-1.854.688-2.622-.112-.75-.783-.638-1.72.155-2.424.755-.676 1.687-.846 2.482-.049.82.822 1.025 1.736-.015 2.592-.137-.15-.297-.268-.505-.302.201.046.368.15.508.295h-.003z",
  fill: "#E46F63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.469 9.743c-.554-.11-1.177.192-2.019-.523.963-.01 1.626-.54 2.016.526h.003v-.003z",
  fill: "#F5645A"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.7,
  d: "M4 0h59v35H4z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cmnd_blur_svg__clip0_193_10343"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(4)",
  d: "M0 0h56v35H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "cmnd_blur_svg__filter0_d_193_10343",
  x: 0,
  y: 0,
  width: 64,
  height: 43,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_193_10343"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_193_10343",
  result: "shape"
})));

function SvgCmndBlur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 52,
    viewBox: "0 0 64 43",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCmndBlur;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/cmnd_blur.svg
// module id = 1310
// module chunks = 10